/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app'),
    api = require('./api'),
    ui  = require('./ui');

module.exports = {
    /**
     * Download intent
     */
    download: function () {
        var item;


        if ( app.list.$focusItem ) {
            item = app.list.$focusItem.data.value;

            core.intent({
                action: 'download',
                silent: true,
                data: {
                    uri: item.url,
                    title: item.title
                }
            });
        }
    },

    /**
     * Delete item
     */
    deleteContent: function () {
        var viewIndex,
            index;

        if ( app.list && app.list.$focusItem && app.list.$focusItem.data && app.list.$focusItem.data.value ) {
            api.deleteContent(app.list.$focusItem.data.value);
            viewIndex = app.list.viewIndex;
            index = app.list.$focusItem.index;

            app.list.data = app.list.data.filter(function ( content ) {
                return content.value !== app.list.$focusItem.data.value;
            });

            app.list.setData({
                data: app.list.data,
                viewIndex: viewIndex
            });

            if ( app.list.data.length ) {
                app.list.focusIndex(--index > 0 ? index : 0);
            }
        }
        if ( !app.list.data.length ) {
            ui.showHelp();
        }
    }
};
